var SharedFeatureFlagModel, SharedUtilsHelper, Support, SupportAppRouter, SupportUtilsHelper, SupportViewManagerFactoryView;

SupportAppRouter = require('./AppRouter');

SupportViewManagerFactoryView = require('./view_manager/view_manager_factory');

SupportUtilsHelper = require('./helpers/utils');

SharedUtilsHelper = require('../../shared/frontend/helpers/utils');

SharedFeatureFlagModel = require('../../shared/frontend/models/feature_flag_model');

Date.now = Date.now || function() {
  return +(new Date);
};

if (!(typeof String.prototype.trim === 'function')) {
  String.prototype.trim = function() {
    return this.replace(/^\s+|\s+$/g, '');
  };
}

Support = {
  createSupportNameSpace: function() {
    var base;
    if (window.Groupon == null) {
      window.Groupon = {};
    }
    if ((base = window.Groupon).Support == null) {
      base.Support = {};
    }
    Groupon.Support.Email = {};
    _.extend(window, SupportUtilsHelper);
    return _.extend(window, SharedUtilsHelper);
  },
  initializeConstants: function() {
    Groupon.Support.FeatureFlagModel = new SharedFeatureFlagModel();
    return Groupon.Support.DELAY_TIMES = {
      flash: 2500
    };
  },
  constructViewManager: function() {
    Groupon.Support.HelpWizardViewManager = SupportViewManagerFactoryView.getViewManager();
    return Groupon.Support.HelpWizardViewManager.render();
  }
};

$(document).ready(function() {
  Support.createSupportNameSpace();
  redirectToFaqHack();
  Support.initializeConstants();
  activateieHacks();
  Support.constructViewManager();
  Groupon.Support.Router = new SupportAppRouter();
  if (!Backbone.History.started) {
    Backbone.history.start({
      root: window.SUPPORTBASEURL
    });
  }
  $('.help-wizard-menu').on('click', function() {
    redirectToHelpWizard();
    return false;
  });
  $('.faqs-menu').on('click', function() {
    redirectToFaq();
    return false;
  });
  Groupon.Performance.pageReady();
  return window.Groupon.ready = true;
});

//# sourceMappingURL=data:application/json;base64,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
